import { Inject, inject, Injectable, isDevMode } from '@angular/core';
import { RxapAuthenticationService } from '@rxap/authentication';
import { KeycloakService } from 'eurogard-keycloak';
import { EurogardAuthenticationService } from './eurogard-authentication.service';
import { NavigationItem, NavigationStatus } from 'angular-components/navigation/navigation-item';
import { filter, firstValueFrom } from 'rxjs';
import { FeatureStatusService } from './feature-status.service';

export interface EurogardNavigationItem extends NavigationItem {
  permissions?: string[];
}

@Injectable({providedIn: 'root'})
export class NavigationStatusService implements NavigationStatus {

  private readonly keycloakService = inject<KeycloakService>(KeycloakService);
  private readonly featureStatusService = inject(FeatureStatusService)

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(@Inject(RxapAuthenticationService) authenticationService: EurogardAuthenticationService) {
  }


  async isVisible(navigationItem: EurogardNavigationItem): Promise<boolean> {
    const featureStatus = await firstValueFrom(this.featureStatusService.status.pipe(filter(value => !!value)));
    if (navigationItem.backendStatusProperty && featureStatus && featureStatus[navigationItem.backendStatusProperty] === false) {
      return false;
    }

    const roles = this.keycloakService.getUserRoles();
    if (navigationItem.permissions?.length) {
      const hasPermission = navigationItem.permissions.some(permission => roles.includes(permission));
      if (isDevMode()) {
        console.warn('NavigationStatusService :: User does not have the required permissions');
      }
      return hasPermission;
    }

    return true;
  }


}
